import { Button, CircularProgress, Grid, Typography } from "@mui/material"
import OneModal from "../../../../Components/OneModal/OneModal"
import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import { UserContext } from "../../../../Providers/UserContext/UserContex"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"
import OneDatePicker from "../../../../Components/OneDatePicker/OneDatePicker"
import moment from "moment"
import AutocompletePessoa from "../../../../Components/AutocompletePessoa/AutocompletePessoa"
import { formatDate, showNotify } from "../../../../Utils/Utils"

const ModalAutorizados = ({ openModal, setOpenModal, id = false, setIdAutorizacao, cd_acesso_visitante }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const [loading, setLoading] = useState(true)
    const { activeCond } = useContext(CondominiosContext)
    const { user } = useContext(UserContext)

    const [initialData, setInitialData] = useState()

    const [formData, setFormData] = useState({
    })

    const getInitialData = (msg) => {
        console.log(msg)
        if (msg.data.status) {
            msg.data.autorizacao[0].dt_inicial = formatDate(msg.data.autorizacao[0].dt_inicial, 'yyyy-MM-DD')
            msg.data.autorizacao[0].dt_final = formatDate(msg.data.autorizacao[0].dt_final, 'yyyy-MM-DD')
            setInitialData({
                ...msg.data.autorizacao[0],
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante
            })
            setFormData({
                ...msg.data.autorizacao[0],
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante
            })
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            addRoute('buscarAutorizacaoByID', getInitialData)
            sendWs('buscarAutorizacaoByID', { id })
        } else {
            setInitialData({
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante,
                dt_inicial: moment().utc().startOf('day').format('yyyy-MM-DD'),
                dt_final: moment().utc().startOf('day').format('yyyy-MM-DD'),
                notificar_morador: 1
            })
            setFormData({
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante,
                dt_inicial: moment().utc().startOf('day').format('yyyy-MM-DD'),
                dt_final: moment().utc().startOf('day').format('yyyy-MM-DD'),
                notificar_morador: 1
            })
            setLoading(false)
        }
    }, [])

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const handleChangeSwitch = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.checked })
    }

    const getResponseAutorizacao = (msg) => {
        if (msg.data.status == true) {
            setIdAutorizacao(null)
            setOpenModal(false)
            showNotify('success', 'Autorização salva com sucesso!')
            sendWs('buscarAutorizadosPorVisitante', { cd_acesso: cd_acesso_visitante, id_central: activeCond.id_central })
        } else {
            showNotify('error', msg.message)
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        addRoute('criarEditarAutorizacao', getResponseAutorizacao)

        if (formData.dt_inicial > formData.dt_final) {
            showNotify('error', 'A data inicial não pode ser maior que a data final!')
            return
        }

        if (!formData.cd_acesso_morador) {
            showNotify('error', 'Morador não selecionado!')
            return
        }

        if (!formData.dt_inicial || !formData.dt_final) {
            showNotify('error', 'Data inicial e data final não podem ser vazias!')
            return
        }

        let finalData = {
            id_central: formData.id_central,
            cd_acesso_morador: formData.cd_acesso_morador,
            id_imovel_morador: formData.id_imovel_morador,
            cd_acesso_visitante: formData.cd_acesso_visitante,
            dt_inicial: formData.dt_inicial,
            dt_final: formData.dt_final,
            notificar_morador: formData.notificar_morador ? 1 : 0
        }

        if (id) {
            finalData.id = id
        }

        sendWs('criarEditarAutorizacao', finalData)
    }

    const handleChangeMorador = (event) => {
        setFormData({
            ...formData,
            morador: event.target.value,
            cd_acesso_morador: event.target.cd_acesso,
            id_imovel_morador: event.target.id_imovel_morador
        })
    }

    return (
        <OneModal
            onClose={() => {
                setIdAutorizacao(null)
            }}
            open={openModal}
            setOpen={setOpenModal}
            titleText={id ? 'Editar Autorização' : 'Adicionar Autorização'}
            FooterButtons={FooterButtons}
        >
            {loading
                ? <CircularProgress />
                : (
                    <>
                        {id && !initialData.cd_acesso_morador
                            ? <Typography sx={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}>Erro ao buscar autorização</Typography>
                            : (<form id="autorizados-form" onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography>*Morador</Typography>
                                        <AutocompletePessoa
                                            key={`${initialData?.morador || "0"}-${initialData?.cd_acesso_morador || "0"}`}
                                            callback={handleChangeMorador}
                                            optionsDefault={[{
                                                nome: initialData?.morador || '',
                                                cd_acesso: initialData?.cd_acesso_morador || '',
                                                imovel: initialData?.imovel || ''
                                            }]}
                                            getOptionLabel={(option) => {
                                                if (!option.nome && !option.imovel) {
                                                    return ""
                                                }
                                                return `${option.nome} - ${option.imovel}`
                                            }}
                                            defaultValue={initialData?.morador || ''}
                                            condominio={initialData?.id_central || formData?.id_central || ''}
                                            newSx={{ height: '45px', fontSize: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography>*Data Inicial</Typography>
                                        <OneDatePicker
                                            name="dt_inicial"
                                            type="date"
                                            defaultValue={initialData?.dt_inicial}
                                            callback={handleChange}
                                            newSx={{ height: '45px', fontSize: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography>*Data Final</Typography>
                                        <OneDatePicker
                                            type="date"
                                            name="dt_final"
                                            defaultValue={initialData?.dt_final}
                                            callback={handleChange}
                                            newSx={{ height: '45px', fontSize: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        gap={2}>
                                        <Typography>Notificar Morador</Typography>
                                        <OneSwitch
                                            name="notificar_morador"
                                            defaultValue={initialData.notificar_morador || ''}
                                            onChange={handleChangeSwitch}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </form>)}
                    </>
                )}
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="autorizados-form" type="submit">Salvar</Button>
        </Grid>
    )
}

export default ModalAutorizados
